import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/inter";
import "./index.css";
import "@glideapps/glide-data-grid/dist/index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { LinearProgress } from "@mui/joy";
import { LanguageProvider } from "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <LanguageProvider>
      <RouterProvider router={router} fallbackElement={<LinearProgress />} />
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
